import React, { useEffect, useState } from "react";
import lodash from "lodash";
import {
  CircularProgress,
} from "@chakra-ui/react";
import { useAssessmentContext } from "hooks/assessment";

interface CategoryProgressProps {
  tags: string[]

}

const CategoryProgress: React.FC<CategoryProgressProps> = ({ tags }) => {

  const { responses, getValue } = useAssessmentContext();

  const [isAllChecked, setIsAllChecked] = useState<boolean>(false);
  const [percentageChecked, setPercentageChecked] = useState<number>(0)

  // returns true if a topic has been filled out
  // otherwise returns false
  const hasResponses = (topic: any) => {
    return topic.overall?.value != null;
    //return lodash.values(topic)
    //  .map(m => m.value)
    //  .filter(v => v != null)
    //  .length > 0
  }

  const getPercentageChecked = () => {
    // TODO get aggregations from AssessmentContext Here
    const categoryResponses = getValue(tags);
    const topics = lodash.values(categoryResponses)

    const topicsFilled = topics.map(hasResponses).filter(v => v);

    const percentFilled_ = (topicsFilled.length / topics.length) * 100;

    setPercentageChecked(percentFilled_);

    if (percentFilled_ > 99) {
      setIsAllChecked(true);
    }
    else {
      setIsAllChecked(false);
    }
  }

  useEffect(() => { getPercentageChecked() }, [responses])

  return (
    <>
      {
        isAllChecked ?
          (
            <div className="checkmark" >✔</div>
          ) :
          (
            <CircularProgress value={percentageChecked} color="blue.500" size="18px" />
          )
      }
    </>);
}

export default CategoryProgress;
